import pimg1 from '../images/project/img-2.jpg';
import pimg2 from '../images/project/img-3.jpg';
import pimg3 from '../images/project/img-1.jpg';
import pimg4 from '../images/project/img-1.jpg';

// import pimg7 from '../images/project/img-7.jpg';
// import pimg8 from '../images/project/img-8.jpg';
// import pimg9 from '../images/project/img-9.jpg';
// import pimg10 from '../images/project/img-10.jpg';
// import pimg11 from '../images/project/img-11.jpg';
// import pimg12 from '../images/project/img-12.jpg';


// import p2img1 from '../images/project-single/1.jpg'
// import p2img2 from '../images/project-single/2.jpg'
// import p2img3 from '../images/project-single/3.jpg'
// import p2img4 from '../images/project-single/4.jpg'
// import p2img5 from '../images/project-single/5.jpg'
// import p2img6 from '../images/project-single/6.jpg'
// import p2img7 from '../images/project-single/7.jpg'
// import p2img8 from '../images/project-single/8.jpg'
// import p2img9 from '../images/project-single/9.jpg'
// import p2img10 from '../images/project-single/10.jpg'
// import p2img11 from '../images/project-single/11.jpg'
// import p2img12 from '../images/project-single/12.jpg'




const Projects = [
    {
        id: '01',
        subtitle: 'Быстрая доставка',
        title: 'Быстрая доставка',
        docomunt: 'Наша компания предлагает услуги быстрой доставки для тех, кто ценит время и нуждается в оперативном решении транспортных задач.',
        slug: 'Special-Transport-Solutions',
        pimg: pimg1,
        location: '7 Lake Street,London',
        date: '15 Dec 2024',
    },
    {
        id: '02',
        subtitle: 'Ценообразование',
        title: 'Ценообразование',
        docomunt: 'Стоимость наших услуг рассчитывается индивидуально, с учетом специфики вашего груза, маршрута и дополнительных требований.',
        slug: 'Special-Transport-Solutions2',
        pimg: pimg2,

        location: '7 Lake Street,London',
        date: '15 Dec 2024',
    },

    {
        id: '03',
        subtitle: 'Безопасность',
        title: 'Безопасность',
        docomunt: 'Полный контроль и сохранность грузов на всех стадиях транспортировки. ',
        slug: 'Special-Transport-Solutions',
        pimg: pimg3,
        location: '7 Lake Street,London',
        date: '15 Dec 2024',
    },

    {
        id: '04',
        subtitle: 'Безопасность',
        title: 'Безопасность',
        docomunt: 'Полный контроль и сохранность грузов на всех стадиях транспортировки. ',
        pimg: pimg4,
        location: '7 Lake Street,London',
        date: '15 Dec 2024',
    },




]
export default Projects;






